/**
 * @generated SignedSource<<92ac089b38cc2c65cddc39d32a409beb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceSendNotesModalMutation$variables = {
  confluencePageId: string;
  confluenceSpaceId: string;
  includeMeetingRecap: boolean;
  noteId: string;
  title?: string | null;
};
export type ConfluenceSendNotesModalMutation$data = {
  readonly sendNoteToConfluence: {
    readonly asyncResultId: any | null;
  } | null;
};
export type ConfluenceSendNotesModalMutation = {
  response: ConfluenceSendNotesModalMutation$data;
  variables: ConfluenceSendNotesModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "confluencePageId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "confluenceSpaceId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMeetingRecap"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "confluencePageId",
        "variableName": "confluencePageId"
      },
      {
        "kind": "Variable",
        "name": "confluenceSpaceId",
        "variableName": "confluenceSpaceId"
      },
      {
        "kind": "Variable",
        "name": "includeMeetingRecap",
        "variableName": "includeMeetingRecap"
      },
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "SendNoteToConfluence",
    "kind": "LinkedField",
    "name": "sendNoteToConfluence",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "asyncResultId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfluenceSendNotesModalMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ConfluenceSendNotesModalMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "d0d19ed188de4962d7aa101a38909634",
    "id": null,
    "metadata": {},
    "name": "ConfluenceSendNotesModalMutation",
    "operationKind": "mutation",
    "text": "mutation ConfluenceSendNotesModalMutation(\n  $title: String\n  $noteId: ID!\n  $confluencePageId: String!\n  $confluenceSpaceId: String!\n  $includeMeetingRecap: Boolean!\n) {\n  sendNoteToConfluence(title: $title, noteId: $noteId, confluencePageId: $confluencePageId, confluenceSpaceId: $confluenceSpaceId, includeMeetingRecap: $includeMeetingRecap) {\n    asyncResultId\n  }\n}\n"
  }
};
})();

(node as any).hash = "78ba2672b71249f04324d2768e0c8ea7";

export default node;
